import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

// get geographical areas
export const GetGeographicalAreasSchema = z.object({
  memberCountry: z.string().min(2),
});

export const GeographicalAreasListResultSchema = z.array(z.string());

// geographical areas result
export const GeographicalAreasResultSchema = z.object({
  countryGroup: z.string().optional(),
  language: z.string().optional(),
  abbreviation: z.string().optional(),
  abbreviation1: z.string().optional(),
  countryGroupDescription: z.string().optional(),
  memberCountry: z.string().optional(),
  description: z.string().optional(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  mbshipStartDate: z.string().optional(),
  mbshipEnsDate: z.string().optional(),
});

// update geographical areas
export const UpdateGeographicalAreasSchema = z.object({});

export const geographicalAreasContract = c.router({
  getGeographicalAreas: {
    method: 'GET',
    path: '/external-api/geographical-areas',
    query: GetGeographicalAreasSchema,
    responses: { 200: GeographicalAreasListResultSchema },
  },
});
